<template lang="pug">
div
    .box
        .box-header.dker
            h3
                span(v-if="stockRequest.status == 0") Stock Request - Step 2 of 5
                span(v-if="stockRequest.status == 2 || stockRequest.status == 1") Stock Request - Step 3 of 5
                span(v-if="stockRequest.status == 3") Stock Request - Step 4 of 5
                span(v-if="stockRequest.status == 4") Stock Request - Step 5 of 5

        .box-divider.m-a-0.p-a-0

        .box-body
            .p-a(v-show="!isDeclined")
                step-wizard(:status="stockRequest.status")

            .warning.p-a(v-if="isDeclined")
                div(v-if="rejector !== null")
                    .clear
                        | Request has been declined by 
                        span._500 {{ rejector.name }} 
                        | on {{ formattedDate(stockRequest.rejected_at) }}.

                    p.m-t-sm.m-b-xs
                        i.material-icons format_quote
                        i {{ stockRequest.rejected_reason }}

                div(v-else) Request has been declined 

        .box-header
            h3 General

        .box-divider.m-a-0.p-a-0

        .box-body
            .row
                .col-sm-6
                    table.table.table-borderless
                        tr
                            td._500 Reference Id
                            td {{ stockRequest.reference_id }}

                        tr
                            td._500 Name
                            td
                                .form-group(v-if="canUpdate && isOpen")
                                    input.form-control.w-lg(
                                        key="request-name",
                                        :class="{ 'has-error': errors.has('name') }"
                                        type="text",
                                        name="name",
                                        v-validate="'required'",
                                        :value="stockRequest.name",
                                        @input="setStockRequestAttr({ key: 'name', value: $event.target.value })"
                                    )

                                span(v-else) {{ stockRequest.name }}

                        tr
                            td._500 Status
                            td
                                span.label.blue-grey(v-if="stockRequest.status == 0") Open
                                span.label.danger(v-if="stockRequest.status == 1") Rejected
                                span.label.yellow(v-if="stockRequest.status == 2") Waiting Approval
                                span.label.info(v-if="stockRequest.status == 3") Approved
                                span.label.green(v-if="stockRequest.status == 4") Received


                .col-sm-6
                    table.table.table-form-input
                        tr
                            td._500 Prefer Transfer Date
                            td
                                vue-datepicker(
                                    v-show="canUpdate && isOpen",
                                    type="datetime"
                                    v-model="transferDate",
                                    lang="en",
                                    :editable="false",
                                    :clearable="false",
                                    :shortcuts="false",
                                    format="DD/MM/YYYY hh:mm:ss a"
                                    :time-picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"
                                )
                                span(v-show="!canUpdate || !isOpen") {{ formattedDate(transferDate) }}

                        tr
                            td._500 Source Outlet
                            td {{ request_from_outlet.name }}

                        tr
                            td._500 Destination Outlet
                            td {{ request_to_outlet.name }}

                        tr
                            td._500 General Notes
                            td
                                textarea.form-control(
                                    v-if="canUpdate && isOpen",
                                    rows="3",
                                    :value="stockRequest.description",
                                    @input="setStockRequestAttr({ key: 'description', value: $event.target.value })"
                                )
                                span(v-else) {{ stockRequest.description }}

</template>

<script>
import stockRequestMixin from './stock-request-mixin';
import { mapActions, mapGetters } from 'vuex';
import stepWizard from './stock-request-step.vue';

export default {
    inject: ['$validator'],

    components: { stepWizard },

    mixins: [stockRequestMixin],

    computed: {
        ...mapGetters('stockRequest', ['rejector']),

        transferDate: {
            get() {
                return this.stockRequest.preferred_stock_transfer_date;
            },
            set(datetime) {
                const value = moment(datetime).format();
                this.setStockRequestAttr({
                    key: 'preferred_stock_transfer_date',
                    value,
                });
            },
        },
    },

    methods: {
        ...mapActions('stockRequest', ['setStockRequestAttr']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_request/stock-request-edit-info.vue